/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useMemo } from "react";
import { useApiIsLoaded, useMap } from "@vis.gl/react-google-maps";

type DSGoogleMapsProviderProps = {
  children: React.ReactNode;
};

export type DSGoogleMapsContextData = {
  map: google.maps.Map | null;
  services:
    | {
        autocompleteService: null;
        placeService: null;
      }
    | {
        autocompleteService: google.maps.places.AutocompleteService;
        placeService: google.maps.places.PlacesService | null;
      };
};

export const DSGoogleMapsContext = createContext<DSGoogleMapsContextData>(
  {} as DSGoogleMapsContextData
);

export function DSGoogleMapsProvider({ children }: DSGoogleMapsProviderProps) {
  const isLoaded = useApiIsLoaded();
  const map = useMap("DS-MAP");

  const services = useMemo(() => {
    if (!isLoaded) return { autocompleteService: null, placeService: null };

    try {
      const autocompleteService = new google.maps.places.AutocompleteService();
      let placeService: google.maps.places.PlacesService | null = null;
      if (map) {
        console.log("O mapa foi inicíado ::>", map);
        placeService = new google.maps.places.PlacesService(map!);
      } else {
        console.log("O mapa não foi inicíado ::>", map);
      }

      return {
        autocompleteService,
        placeService,
      };
    } catch (error) {
      console.error("Error initializing Google Maps services:", error);
      return { autocompleteService: null, placeService: null };
    }
  }, [isLoaded, map]);

  const GoogleMapsContextData = useMemo(() => {
    return { map, services };
  }, [map, services]);

  return (
    <DSGoogleMapsContext.Provider value={GoogleMapsContextData}>
      {children}
    </DSGoogleMapsContext.Provider>
  );
}
